import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-429f5f8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "m-question-wrap",
  ref: "swipWrap"
}
const _hoisted_2 = {
  key: 0,
  class: "progress-group u-top m-section-title"
}
const _hoisted_3 = { class: "number-tip" }
const _hoisted_4 = { class: "current" }
const _hoisted_5 = ["initial-swipe"]
const _hoisted_6 = {
  key: 0,
  class: "m-footer"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-seperator-bar" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "m-button-wrap"
}
const _hoisted_9 = {
  key: 3,
  class: "u-button-tile disabled"
}
const _hoisted_10 = {
  key: 1,
  class: "m-button-wrap"
}
const _hoisted_11 = {
  key: 1,
  class: "u-button-tile disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_bar = _resolveComponent("action-bar")!
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_question_detail = _resolveComponent("question-detail")!

  return (_openBlock(), _createElementBlock("div", {
    class: "m-analysis-wrap",
    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.preventDefaultEvent && $setup.preventDefaultEvent(...args)), ["prevent"]))
  }, [
    ($setup.showActionBar)
      ? (_openBlock(), _createBlock(_component_action_bar, {
          key: 0,
          class: "m-action-bar",
          onGoBack: $setup.goBack,
          needShare: false,
          actionBarInfo: $setup.actionBarInfo,
          backIcon: $setup.backIcon
        }, null, 8, ["onGoBack", "actionBarInfo", "backIcon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "m-paper-info",
      style: _normalizeStyle({ paddingTop: $setup.showActionBar ? $setup.actionBarHeight + 'px' : '0' })
    }, [
      _createElementVNode("div", _hoisted_1, [
        ($setup.isWeekStudy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_van_progress, {
                "stroke-width": 8,
                percentage: (($setup.currentIndex + 1) / $setup.questionList.length) * 100,
                "show-pivot": false,
                class: "progress"
              }, null, 8, ["percentage"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString($setup.currentIndex + 1), 1),
                _createElementVNode("span", null, "/" + _toDisplayString($setup.questionList.length), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.questionList, (question, index) => {
          return (_openBlock(), _createElementBlock("div", {
            ref_for: true,
            ref: "swipeBoxInner",
            "initial-swipe": $setup.initialIndex,
            key: index
          }, [
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_question_detail, {
                onXesEvent: $setup.testClickEvent,
                questionIndex: index,
                currentIndex: $setup.currentIndex,
                questionData: {
                list: question,
                total: $setup.questionList.length,
                isRight: $setup.queResList?.[index]?.ansResStatus === 1
              },
                submitQestionMap: $setup.submitQestionMap
              }, null, 8, ["onXesEvent", "questionIndex", "currentIndex", "questionData", "submitQestionMap"])
            ], 512), [
              [_vShow, index === $setup.currentIndex]
            ])
          ], 8, _hoisted_5))
        }), 128))
      ], 512),
      (
          $setup.questionList &&
          ($setup.questionList?.length > 1 || ($setup.questionList?.length === 1 && !$setup.showActionBar))
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            ($setup.swipeBoxInner && !$setup.showActionBar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (!$setup.currentIndex)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "u-button-tile",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
                      }, "返回"))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["u-button-tile", { disabled: !$setup.currentIndex }]),
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handlePrev && $setup.handlePrev(...args)))
                      }, " 上一题 ", 2)),
                  ($setup.currentIndex !== $setup.questionList.length - 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "u-button-tile",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleNext && $setup.handleNext(...args)))
                      }, " 下一题 "))
                    : _createCommentVNode("", true),
                  ($setup.currentIndex && $setup.currentIndex === $setup.questionList.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 下一题 "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            ($setup.swipeBoxInner && $setup.showActionBar && $setup.questionList?.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["u-button-tile", { disabled: !$setup.currentIndex }]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handlePrev && $setup.handlePrev(...args)))
                  }, " 上一题 ", 2),
                  ($setup.currentIndex !== $setup.questionList.length - 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "u-button-tile",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleNext && $setup.handleNext(...args)))
                      }, " 下一题 "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, "下一题"))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}